import React from "react";

import { IconProps } from "./../types";
import { BaseSVGIcon } from "./base-svg-icon";

export const DropdownArrow: React.FC<IconProps> = (props) => {
  return (
    <BaseSVGIcon width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path d="M1 1L5 5L9 1" stroke="black" strokeWidth="2" strokeLinecap="round" />
    </BaseSVGIcon>
  );
};
